import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BilSharedService } from '@app/shared/service/bil-shared.service';
import { MatDialogRef, MatDialog } from '@angular/material';
import { BilUploadDocumentsService } from '@app/modules/bil-upload-document/services/bil-upload-documents.service';
import * as URL_CONSTANT from '../../config/bil-desktop-constant';
import { ChangeDocumentAlertBoxComponent } from '../change-document-alert-box/change-document-alert-box.component';

@Component({
  selector: 'bil-bil-add-partner-dialog',
  templateUrl: './bil-add-partner-dialog.component.html',
  styleUrls: ['./bil-add-partner-dialog.component.sass']
})
export class BilAddPartnerDialogComponent implements OnInit {
  addPartnerForm: FormGroup;
  public partnersList: any = [];
  public partnerNames = [];
  public stakeHolderType: string;
  public message: string;

  constructor(private sharedService: BilSharedService,
    private partnerService: BilUploadDocumentsService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<BilAddPartnerDialogComponent>,
  ) {
    console.log(URL_CONSTANT);
  }

  ngOnInit() {
    this.addPartnerForm = new FormGroup({
      'firstName': new FormControl('', Validators.required),
      'lastName': new FormControl('', Validators.required),
    });

    let fourthCharacter = this.partnerService.getFourthCharacter();
    if (fourthCharacter.toUpperCase() === 'C') {
      this.stakeHolderType = 'Director';
    } else if (fourthCharacter.toUpperCase() === 'F') {
      this.stakeHolderType = 'Partner';
    }
  }

  closeModal() {
    this.dialogRef.close(true);
  }

  /**
  * @method addPartner
  * @description Adding the parnters for the patnership flow
  * @param null
  * @return void
  */
  addPartner() {
    this.partnerService.getStakeHolder().subscribe(res => {
      this.partnersList = JSON.parse(JSON.stringify(res));
      this.partnersList.forEach((partner) => {
        this.partnerNames.push(partner.name);
      });
      const isPartnerPresent = this.partnerNames.find((name) => {
        const splitPartnerName = name.trim().toUpperCase().split(/\s+/);
        const firstNameForm = this.addPartnerForm.controls['firstName'].value.trim().toUpperCase();
        const lastNameForm = this.addPartnerForm.controls['lastName'].value.trim().toUpperCase();

        const enteredName = firstNameForm + ' ' + lastNameForm;
        const splitEnteredName = enteredName.trim().toUpperCase().split(/\s+/);

        let isNameEqual = true;

        if (splitPartnerName.length === splitEnteredName.length) {
          for (let i = 0; i < splitPartnerName.length; i++) {
            if (splitPartnerName[i].trim() !== splitEnteredName[i].trim()) {
              isNameEqual = false;
            }
          }
        } else {
          isNameEqual = false;
        }
        return isNameEqual;
      });

      if (!isPartnerPresent) {
        this.sharedService.addPartner(this.addPartnerForm.value).subscribe(res => {
          if (res['status'] == "Success") {
            this.dialogRef.close();
          } else {
          }
        });
      } else {
        if (this.stakeHolderType === 'Partner') {
          this.message = URL_CONSTANT.DUPLICATE_PARTNER_NAME;
        } else if (this.stakeHolderType === 'Director') {
          this.message = URL_CONSTANT.DUPLICATE_DIRECTOR_NAME;
        }

        const requestForModal = {
          message: this.message,
          backLabel: 'Cancel',
          submitButtonName: 'Proceed'
        };
        const dialogRef = this.dialog.open(ChangeDocumentAlertBoxComponent, {
          height: '30%',
          width: '30%',
          data: {
            requestForModal
          }
        });
        dialogRef.afterClosed().subscribe(onModalClose => {
          if (onModalClose.event == 'onNext') {
            this.sharedService.addPartner(this.addPartnerForm.value).subscribe(res => {
              if (res['status'] == "Success") {
                this.dialogRef.close();
              } else {
              }
            });
          } else {
            this.dialogRef.close();
            // do nothing
          }
        });
      }

    });
  }

}
